import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MalwareScanningStatus } from '../../../../interfaces';
import { MalwareScanMonitorService } from '../../../../services/signed-url/malware-scan-monitor.service';
import { Subscription } from 'rxjs';
import { EmitterService } from '../../../../services/emitter.service';
import { FileScannedTranscodedEvent } from '../../../../models';
import { FileUtilsService } from '../../../../services/file-utils.service';

@Component({
  selector: 'mtm-asset-scan-info',
  templateUrl: './asset-scan-info.component.html',
  styleUrl: './asset-scan-info.component.scss',
  standalone: false,
})
export class AssetScanInfoComponent implements OnDestroy {
  private readonly scanMonitorService = inject(MalwareScanMonitorService);
  private readonly fileUtilsService = inject(FileUtilsService);

  private _file: any;

  get file(): any {
    return this._file;
  }

  @Input()
  set file(value: any) {
    if (value === this._file) {
      return;
    }

    this._file = value;
    if (value?.malwareScanningStatus === MalwareScanningStatus.Unscanned) {
      this.monitorFile();
    }
  }

  @Output() scanFinished = new EventEmitter<void>();

  private scanUpdateSubscription: Subscription;
  protected readonly MalwareScanningStatus = MalwareScanningStatus;

  ngOnDestroy() {
    if (this.scanUpdateSubscription) {
      this.scanUpdateSubscription.unsubscribe();
    }
  }

  monitorFile() {
    if (this.scanUpdateSubscription) {
      this.scanUpdateSubscription.unsubscribe();
    }
    const update$ = this.scanMonitorService.monitorFile({
      fileId: this.file.id,
      projectId: this.file.projectId,
    });
    this.scanUpdateSubscription = update$.subscribe((file) => {
      if (!file) {
        return;
      }

      if (file.malwareScanningStatus !== MalwareScanningStatus.Unscanned) {
        if (file.hasPage) {
          EmitterService.get(FileScannedTranscodedEvent).emit(file);
        }
        this.fileUtilsService.copyFilePropsAfterScanning(file, this.file);
        this.scanFinished.emit();
      }
    });
  }
}
